import { http } from '@/shared/api/httpClient';
import type {
  PublicBracket,
  PublicClubCompetitions,
  PublicCompetitionInfo,
  PublicCourtSchedule,
  PublicMatches,
  PublicStandings,
} from '../model/publicTypes';

/**
 * Wywolania publicznych endpointow `/api/public/**` — tryb prezentacji.
 *
 * Wszystkie ida z `skipAuth`, bo ekran dziala bez logowania: nie chcemy
 * doklejac przypadkowego tokena ani uruchamiac odswiezania sesji, gdy ktos
 * otworzy ten adres w przegladarce z wygasla sesja w innej karcie.
 */
const PUBLIC_REQUEST = { skipAuth: true, skipRefresh: true } as const;

/** Pobiera publiczne rozgrywki klubu — zrodlo przelacznika turniejow. */
export function getPublicClubCompetitions(clubId: string): Promise<PublicClubCompetitions> {
  return http.get<PublicClubCompetitions>(`/public/clubs/${clubId}/competitions`, PUBLIC_REQUEST);
}

/** Pobiera podsumowanie rozgrywki (nazwa, termin, miejsce, rozmiar drabinki). */
export function getPublicCompetitionInfo(competitionId: string): Promise<PublicCompetitionInfo> {
  return http.get<PublicCompetitionInfo>(`/public/competitions/${competitionId}`, PUBLIC_REQUEST);
}

/** Pobiera drabinke wraz ze slownikiem nazwisk. Wymaga rozlosowanej rozgrywki. */
export function getPublicBracket(competitionId: string): Promise<PublicBracket> {
  return http.get<PublicBracket>(`/public/competitions/${competitionId}/bracket`, PUBLIC_REQUEST);
}

/** Pobiera wszystkie mecze rozgrywki wraz ze slownikiem nazwisk. */
export function getPublicMatches(competitionId: string): Promise<PublicMatches> {
  return http.get<PublicMatches>(`/public/competitions/${competitionId}/matches`, PUBLIC_REQUEST);
}

/** Pobiera tabele grup wraz ze slownikiem nazwisk. */
export function getPublicStandings(competitionId: string): Promise<PublicStandings> {
  return http.get<PublicStandings>(`/public/competitions/${competitionId}/standings`, PUBLIC_REQUEST);
}

/** Pobiera plan kortow na wskazany dzien (format `yyyy-MM-dd`). */
export function getPublicCourtSchedule(
  competitionId: string,
  date: string,
): Promise<PublicCourtSchedule> {
  return http.get<PublicCourtSchedule>(`/public/competitions/${competitionId}/court-schedule`, {
    ...PUBLIC_REQUEST,
    query: { date },
  });
}
